module.exports = "//public.zight.com/packs/media/images/icon-muted@2x-c00ca37476eb8aba689ad6a6033b97f7.png";